import React from 'react';
import { Link } from 'react-router-dom';
import { TestAttempt } from '../../types/models';
import './TestHistory.css';

type TestHistoryProps = {
  attempts: TestAttempt[];
};

export const TestHistory = ({ attempts }: TestHistoryProps) => {
  if (attempts.length === 0) {
    return (
      <div className="history-container">
        <h2>Historia prób</h2>
        <p>Nie rozwiązałeś jeszcze żadnych testów.</p>
      </div>
    );
  }

  return (
    <div className="history-container">
      <h2>Historia prób</h2>
      <table className="history-table">
        <thead>
          <tr>
            <th>Nazwa Testu</th>
            <th>Wynik</th>
            <th>Data</th>
            <th>Akcje</th>
          </tr>
        </thead>
        <tbody>
          {/* Sortujemy od najnowszej próby */}
          {[...attempts].reverse().map((att) => (
            <tr key={att.id}>
              <td>{att.testSetName}</td>
              <td><strong>{att.score} / {att.totalQuestions}</strong></td>
              <td>{new Date(att.dateCompleted).toLocaleDateString('pl-PL')}</td>
              <td>
                <Link to={`/przeglad/${att.id}`}>Szczegóły</Link>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};